import React from 'react';

import ReactEchartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';

import { GridComponent } from 'echarts/components';
import { SVGRenderer } from 'echarts/renderers';
import { ChartContainer } from './styles';

echarts.use([GridComponent, SVGRenderer]);

function GraphComponent({ option }) {
  return (
    <ChartContainer>
      <ReactEchartsCore echarts={echarts} option={option} />
    </ChartContainer>
  );
}

export default GraphComponent;
